export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 pt-14 md:pt-20 pb-8 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12 max-w-6xl mx-auto">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-movie-2-line text-2xl text-primary-500 w-6 h-6 flex items-center justify-center"></i>
              <span className="text-xl font-heading text-foreground-950">91电影</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              91电影是国内领先的免费在线观看平台，每日更新最新国产电影免费大片，提供高清流畅的观影体验，无需付费直接观看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-950 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#carousel" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">焦点专题</a>
              <a href="#features" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">特色优势</a>
              <a href="#ranking" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热播排行</a>
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">主题索引</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-950 mb-4">影片分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#media" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">动作大片</a>
              <a href="#media" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">悬疑推理</a>
              <a href="#media" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">科幻巨制</a>
              <a href="#media" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">喜剧合集</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-950 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500">更多合作伙伴即将加入，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-200/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 max-w-6xl mx-auto">
          <p className="text-xs text-foreground-500">
            &copy; 2024 91电影 · 免费在线观看平台 · 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#about" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">关于我们</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}